<template>
  <div>
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
          <el-form-item label="捆包编号:" prop="cargoBarcode">
            <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.cargoBarcode"></el-input>
          </el-form-item>
          <!-- <el-form-item label="重量:" prop="productName" class="zhong">
            <el-input  placeholder="" v-model="searchFrom.minWeight"></el-input>~
            <el-input  placeholder="" v-model="searchFrom.maxWeight"></el-input>
          </el-form-item> -->
          <el-form-item label="所在仓库:" prop="organizationId">
            <el-select  v-model="searchFrom.organizationId"  placeholder="">
              <el-option v-for="val in warehouseList" :label="val.relTenantName" :value="val.relTenantCode" :key="val.relTenantCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="原客户名称:" prop="oldCustomerName">
            <el-input  placeholder="" v-model="searchFrom.oldCustomerName"></el-input>
          </el-form-item>
          <el-form-item label="新客户名称:" prop="newCustomerName">
            <el-input  placeholder="" v-model="searchFrom.newCustomerName"></el-input>
          </el-form-item>
          <el-form-item label="品名:" prop="productName">
            <el-input  placeholder="" v-model="searchFrom.productName"></el-input>
          </el-form-item>
          <el-form-item label="材质:" prop="model">
            <el-input  placeholder="" v-model="searchFrom.model"></el-input>
          </el-form-item>
          <el-form-item label="规格:" prop="specification">
            <el-input  placeholder="" v-model="searchFrom.specification"></el-input>
          </el-form-item>
          <el-form-item label="变更时间:" prop="instockDate">
            <el-date-picker
              v-model="timecheacked"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                 <el-form-item >
                  <el-button type="primary"  @click="exportFn" :disabled="isDisable">导出</el-button>
                </el-form-item>
                  <el-form-item>
                  <p class="margin0">总件数：<span class="red">{{tongji.allNumber}}</span>件</p>
                </el-form-item>
                <el-form-item>
                  <p class="margin0">总重量：<span class="red">{{tongji.allWeight}}</span>吨</p>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" bordersize="mini" @selection-change='selectGoods' class="tableComent"
       @row-click="handleRowClick" style="width: 100%" height="100%" center border v-loading="loading">
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="createTime"  min-width="200"  label="变更时间"></el-table-column>
        <el-table-column property="cargoBarcode" width="150" label="捆包号"></el-table-column>
        <el-table-column prop="oldCustomerName"  min-width="200" :formatter="emptyFn" label="原客户名称"></el-table-column>
        <el-table-column prop="newCustomerName"  min-width="200" :formatter="emptyFn" label="新客户名称"></el-table-column>
        <el-table-column property="productName" width="100"  label="品名"></el-table-column>
        <el-table-column property="model" width="120" label="材质"></el-table-column>
        <el-table-column property="specification" width="140"  label="规格"></el-table-column>
        <el-table-column property="weight" :formatter="emptyFn"  width="100" label="重量(吨)"></el-table-column>
        <el-table-column prop="number"  width="100" :formatter="emptyFn" label="件数(件)"></el-table-column>
         <el-table-column property="takeGoodStatus" label="货位" >
          <template scope="scope">
            {{scope.row.cargoLocation}}
          </template>
        </el-table-column>
        <el-table-column property="organizationName" width="240" label="所在仓库"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { findCustomerChangesList, getfindCustomerChangesNumber, selectCommonDictionary } from '@/api/soc-stock'
import { exportExcel } from '@/utils/fileDown.js'
export default {
  props: {
    productTypes: {
      type: Array,
      required: true
    },
    warehouseList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      tableArr: [],
      timecheacked: '',
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: 'false',
      goodTypes: [],
      tongji: {},
      isDisable: false,
      oneCustomerTaxId: localStorage.getItem('tenantTaxpayerNumber')
    }
  },
  created () {
    if (this.warehouseList.length > 0) {
      this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
    }
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 202) + 'px'
  },
  methods: {
    // 导出
    exportFn () {
      let form = this.searchFrom
      exportExcel(
        this.global.wmsCenter + '/wmsApi/exportCustomerChangesList',
        form,
        '转货记录'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    searchFn () {
      if (this.timecheacked) {
        this.searchFrom.createTimeStart = this.timecheacked[0]
        this.searchFrom.createTimeEnd = this.timecheacked[1]
      } else {
        this.searchFrom.createTimeStart = null
        this.searchFrom.createTimeEnd = null
      }

      this.getList()
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      if (this.searchFrom.cargoBarcode) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcode.split(/[(\r\n)\r\n]+/).toString() }
      if (this.searchFrom.cargoBarcode == '') { this.searchFrom.cargoBarcodes = '' }
      findCustomerChangesList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      getfindCustomerChangesNumber(this.searchFrom).then(res => {
        this.tongji = res.weight
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        oneOrTwoCustomerTaxId: this.oneCustomerTaxId
      }
      this.timecheacked = null
      if (this.warehouseList.length > 0) {
        this.$set(this.searchFrom, 'organizationId', this.warehouseList[0].relTenantCode)
      }
    },

    closeDialog () {
      this.addFrom = {}
      this.$refs.table.clearSelection()
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
  width: 350px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
